import Organisation from "../../../models/Organisation";
import { getCompetencesLabels } from "../../../utils/competence.utils";
import dayjs from "dayjs";
import { DATE_TIME_FORMAT_TYPES } from "../../../configs/constants/DateTimeFormatTypes";
import { CustomerRating } from "../../../models/CustomerUser";

interface Props {
	// data: CustomerRating;
	// onRowClick: () => void;
	// organization?: Organisation;
}

// TODO: need to change this item when BE is ready
const CustomerFeedback = ({}: /* data, onRowClick, organization */ Props) => {
	// const { id, comment, customer, consultant, metadata, performance, punctualityScore, job } = data;
	// const getRateColor = (rate: number) => {
	// 	return rate < 3 ? "#EB5757" : "#000000";
	// };
	return (
		// <tr key={id} onClick={() => onRowClick()}>
		// 	<td>{`${consultant.firstName} ${consultant.lastName}`}</td>
		// 	<td>
		// 		<span>{`#${job.orderNumber}`}</span>
		// 		<br />
		// 		<span>{` ${customer.name}`}</span>
		// 	</td>
		// 	<td>
		// 		{getCompetencesLabels(organization?.competences ?? [], job.competence, undefined).service}
		// 	</td>
		// 	<td>
		// 		{metadata.createdAt ? dayjs(metadata.createdAt).format(DATE_TIME_FORMAT_TYPES.DATE) : ""}
		// 	</td>
		// 	<td style={{ color: getRateColor((performance + punctualityScore) / 2) }}>
		// 		{(performance + punctualityScore) / 2}
		// 	</td>
		// 	<td>{!!comment ? comment : "-"}</td>
		// </tr>
		<tr>
			<td colSpan={6}></td>
		</tr>
	);
};

export default CustomerFeedback;
